var dataLayer = (window && window.dataLayer) ? window.dataLayer : [];
var options = {
  version: '1.0.0',
  debug: false
};
var defaults = {
  axios: {
    label: {
      data_keys: ['url', 'responseUrl'],
      fallback_keys: ['config', 'request'],
      default_value: 'Unknown URL'
    },
    message: {
      data_keys: ['data.msg', 'data.message', 'message', 'msg', 'statusText', 'responseText', 'text'],
      fallback_keys: undefined,
      default_value: 'Unknown error message'
    },
    status: {
      data_keys: ['status', 'code', 'statusCode', 'responseCode'],
      fallback_keys: undefined,
      default_value: 500
    },
    request_url: {
      data_keys: ['url', 'responseUrl'],
      fallback_keys: ['config', 'request'],
      default_value: 'Unknown URL'
    },
    request_method: {
      data_keys: ['method'],
      fallback_keys: ['config'],
      default_value: 'Unknown method'
    },
    request_body: {
      data_keys: ['data'],
      fallback_keys: ['config'],
      default_value: 'Unknown data'
    }
  },
  videojs: {
    label: {
      data_keys: ['code'],
      fallback_keys: undefined,
      default_value: 500
    },
    message: {
      data_keys: ['message'],
      fallback_keys: undefined,
      default_value: 'Unknown error message'
    },
    code: {
      data_keys: ['code'],
      fallback_keys: undefined,
      default_value: 500
    },
    location: {
      data_keys: ['location', 'file', 'filename', 'fileName'],
      fallback_keys: undefined,
      default_value: 'Unknown location'
    }
  },
  vue: {
    label: {
      data_keys: ['location', 'file', 'filename', 'fileName'],
      fallback_keys: undefined,
      default_value: 'Unknown file location'
    },
    name: {
      data_keys: ['name'],
      fallback_keys: undefined,
      default_value: 'Unknown error name'
    },
    message: {
      data_keys: ['message'],
      fallback_keys: undefined,
      default_value: 'Unknown error message'
    },
    location: {
      data_keys: ['location', 'file', 'filename', 'fileName'],
      fallback_keys: undefined,
      default_value: 'Unknown file location'
    },
    scope: {
      data_keys: ['scope'],
      fallback_keys: undefined,
      default_value: 'Unknown scope'
    }
  },
  error: {
    label: {
      data_keys: ['status', 'code', 'statusCode', 'responseCode', 'errno'],
      fallback_keys: ['error', 'err', 'data', 'body', 'response', 'responseJSON', 'responseJSON.errorData', 'responseJSON.error', 'error.sql', 'component'],
      default_value: 500
    },
    message: {
      data_keys: ['message', 'msg', 'errorMessage', 'responseText', 'statusText', 'errorText', 'text', 'name', 'type'],
      fallback_keys: ['error', 'err', 'data', 'body', 'response', 'responseJSON', 'responseJSON.errorData', 'responseJSON.error', 'error.sql', 'component'],
      default_value: 'Unknown error message'
    },
    status: {
      data_keys: ['status', 'code', 'statusCode', 'responseCode', 'errno'],
      fallback_keys: ['error', 'err', 'data', 'body', 'response', 'responseJSON', 'responseJSON.errorData', 'responseJSON.error', 'error.sql', 'component'],
      default_value: 500
    },
    location: {
      data_keys: ['location', 'file', 'filename', 'fileName'],
      fallback_keys: ['error', 'err', 'data', 'body', 'response', 'responseJSON', 'responseJSON.errorData', 'responseJSON.error', 'error.sql', 'component'],
      default_value: 'Unknown location'
    }
  }
};
var valid_default_paths = (function () {
  var valid = [];
  Object.keys(defaults).forEach(function (key1) {
    Object.keys(defaults[key1]).forEach(function (key2) {
      Object.keys(defaults[key1][key2]).forEach(function (key3) {
        valid.push([key1, key2, key3]);
      });
    });
  });
  return valid;
})();

var constructData = function (ref) {
  var data = ref.data; if ( data === void 0 ) data = {};
  var data_keys = ref.data_keys; if ( data_keys === void 0 ) data_keys = [];
  var fallback_keys = ref.fallback_keys; if ( fallback_keys === void 0 ) fallback_keys = ['data', 'response', 'response.data', 'response.request'];
  var default_value = ref.default_value; if ( default_value === void 0 ) default_value = 'Unknown';

  var getData = function (obj) {
    var constructed_data = null;
    data_keys.forEach(function (dk) {
      if (constructed_data === null && _.has(obj, dk)) { constructed_data = _.get(obj, dk); }
    });
    return constructed_data;
  };
  var constructed_data = getData(data);
  if (constructed_data !== null) { return constructed_data; }
  fallback_keys.forEach(function (fk) {
    if (constructed_data === null && _.has(data, fk)) { constructed_data = getData(_.get(data, fk)); }
  });
  return constructed_data || default_value;
};

var constructError = function (error, options) {
  if (typeof error === 'string') { error = {message: error}; }
  if (typeof options === 'string') { options = {location: options}; }
  if (typeof error !== 'object') { error = {}; }
  if (typeof options !== 'object') { options = {}; }
  return _.assign({}, error, options);
};

var objectLog = function (obj) {
  var final = {
    'event': 'GALogger',
    'log-category': obj.category || 'ERROR',
    'log-action': typeof obj.action === 'string' ? obj.action : JSON.stringify(obj.action),
    'log-label': ("[" + (options.version) + "] " + (obj.label || 'Unknown label')),
    'log-value': Date.now()
  };
  if (options.debug) { console.log('[playposit-analytics]', final); }
  if (dataLayer) { dataLayer.push(final); }
};

dataLayer.manualLog = function (action, category) {
  if ( action === void 0 ) action = 'An unknown error has occurred.';
  if ( category === void 0 ) category = 'ERROR';

  objectLog({
    category: category,
    label: "Manual",
    action: action
  });
};

dataLayer.axiosLog = function (error, options) {
  if ( options === void 0 ) options = {};

  error = constructError(error, options);
  objectLog({
    category: 'ERROR',
    label: ("Axios - " + (constructData({
        data: error.response,
        data_keys: error.label_data_keys || defaults.axios.label.data_keys,
        fallback_keys: error.label_fallback_keys || defaults.axios.label.fallback_keys,
        default_value: error.label_default_value || defaults.axios.label.default_value
      }).split('?')[0])),
    action: {
      message: constructData({
        data: error.response,
        data_keys: error.message_data_keys || defaults.axios.message.data_keys,
        fallback_keys: error.message_fallback_keys || defaults.axios.message.fallback_keys,
        default_value: error.message_default_value || defaults.axios.message.default_value
      }),
      status: constructData({
        data: error.response,
        data_keys: error.status_data_keys || defaults.axios.status.data_keys,
        fallback_keys: error.status_fallback_keys || defaults.axios.status.fallback_keys,
        default_value: error.status_default_value || defaults.axios.status.default_value
      }),
      request_url: constructData({
        data: error.response,
        data_keys: error.request_url_data_keys || defaults.axios.request_url.data_keys,
        fallback_keys: error.request_url_fallback_keys || defaults.axios.request_url.fallback_keys,
        default_value: error.request_url_default_value || defaults.axios.request_url.default_value
      }),
      request_method: constructData({
        data: error.response,
        data_keys: error.request_method_data_keys || defaults.axios.request_method.data_keys,
        fallback_keys: error.request_method_fallback_keys || defaults.axios.request_method.fallback_keys,
        default_value: error.request_method_default_value || defaults.axios.request_method.default_value
      }),
      request_body: (function () {
        var request_body = constructData({
          data: error.response,
          data_keys: error.request_body_data_keys || defaults.axios.request_body.data_keys,
          fallback_keys: error.request_body_fallback_keys || defaults.axios.request_body.fallback_keys,
          default_value: error.request_body_default_value || defaults.axios.request_body.default_value
        });
        try {
          return JSON.parse(request_body);
        } catch(e) {
          return request_body;
        }
      })()
    },
  });
};

dataLayer.videojsLog = function (error, options) {
  if ( options === void 0 ) options = {};

  error = constructError(error, options);
  objectLog({
    category: 'ERROR',
    label: ("VideoJS - " + (constructData({
      data: error,
      data_keys: error.label_data_keys || defaults.videojs.label.data_keys,
      fallback_keys: error.label_fallback_keys || defaults.videojs.label.fallback_keys,
      default_value: error.label_default_value || defaults.videojs.label.default_value
    }))),
    action: {
      message: constructData({
        data: error,
        data_keys: error.message_data_keys || defaults.videojs.message.data_keys,
        fallback_keys: error.message_fallback_keys || defaults.videojs.message.fallback_keys,
        default_value: error.message_default_value || defaults.videojs.message.default_value
      }),
      code: constructData({
        data: error,
        data_keys: error.code_data_keys || defaults.videojs.code.data_keys,
        fallback_keys: error.code_fallback_keys || defaults.videojs.code.fallback_keys,
        default_value: error.code_default_value || defaults.videojs.code.default_value
      }),
      location: constructData({
        data: error,
        data_keys: error.location_data_keys || defaults.videojs.location.data_keys,
        fallback_keys: error.location_fallback_keys || defaults.videojs.location.fallback_keys,
        default_value: error.location_default_value || defaults.videojs.location.default_value
      })
    },
  });
};

dataLayer.vueLog = function (error, options) {
  if ( options === void 0 ) options = {};

  error = constructError(error, options);
  objectLog({
    category: 'ERROR',
    label: ("Vue - " + (constructData({
      data: error,
      data_keys: error.label_data_keys || defaults.vue.label.data_keys,
      fallback_keys: error.label_fallback_keys || defaults.vue.label.fallback_keys,
      default_value: error.label_default_value || defaults.vue.label.default_value
    }))),
    action: {
      name: constructData({
        data: error,
        data_keys: error.name_data_keys || defaults.vue.label.data_keys,
        fallback_keys: error.name_fallback_keys || defaults.vue.label.fallback_keys,
        default_value: error.name_default_value || defaults.vue.label.default_value
      }),
      message: constructData({
        data: error,
        data_keys: error.message_data_keys || defaults.vue.message.data_keys,
        fallback_keys: error.message_fallback_keys || defaults.vue.message.fallback_keys,
        default_value: error.message_default_value || defaults.vue.message.default_value
      }),
      location: constructData({
        data: error,
        data_keys: error.location_data_keys || defaults.vue.location.data_keys,
        fallback_keys: error.location_fallback_keys || defaults.vue.location.fallback_keys,
        default_value: error.location_default_value || defaults.vue.location.default_value
      }),
      scope: constructData({
        data: error,
        data_keys: error.scope_data_keys ||defaults.vue.scope.data_keys,
        fallback_keys: error.scope_fallback_keys || defaults.vue.scope.fallback_keys,
        default_value: error.scope_default_value || defaults.vue.scope.default_value
      })
    },
  });
};

dataLayer.errorLog = function (error, options) {
  if ( options === void 0 ) options = {};

  error = constructError(error, options);
  objectLog({
    category: 'ERROR',
    label: ("Client - " + (constructData({
      data: error,
      data_keys: error.label_data_keys || defaults.error.label.data_keys,
      fallback_keys: error.label_fallback_keys || defaults.error.label.fallback_keys,
      default_value: error.label_default_value || defaults.error.label.default_value
    }))),
    action: {
      message: constructData({
        data: error,
        data_keys: error.message_data_keys || defaults.error.message.data_keys,
        fallback_keys: error.message_fallback_keys || defaults.error.message.fallback_keys,
        default_value: error.message_default_value || defaults.error.message.default_value
      }),
      status: constructData({
        data: error,
        data_keys: error.status_data_keys || defaults.error.status.data_keys,
        fallback_keys: error.status_fallback_keys || defaults.error.status.fallback_keys,
        default_value: error.status_default_value || defaults.error.status.default_value
      }),
      location: constructData({
        data: error,
        data_keys: error.location_data_keys || defaults.error.location.data_keys,
        fallback_keys: error.location_fallback_keys || defaults.error.location.fallback_keys,
        default_value: error.location_default_value || defaults.error.location.default_value
      })
    },
  });
};

window.onerror = function (message, url, line, col, error) {
  objectLog({
    category: 'JSERROR',
    label: ("Window - " + message),
    action: {
      message: message,
      url: url,
      line: line,
      col: col,
      error: error
    },
  });
};

var analytics = {
  updateOptions: function (new_options) {
    if (!_.isObject(new_options)) {
      return console.warn('[playposit-analytics] Argument for updateOptions() must be an object. Acceptable properties of that object are: {version, debug}');
    }
    Object.keys(new_options).forEach(function (key) {
      if (_.has(options, key)) { options[key] = new_options[key]; }
    });
    if (options.debug) { console.log('[playposit-analytics] Updated options', options); }
  },
  updateDefaults: function (new_defaults) {
    if (!_.isObject(new_defaults)) {
      return console.warn('[playposit-analytics] Argument for updateDefaults() must be an object.');
    }
    valid_default_paths.forEach(function (vdp) {
      if (_.get(new_defaults, vdp) && _.has(defaults, vdp)) {
        if (['data_keys', 'fallback_keys'].includes(vdp[vdp.length -1]) && !_.isArray(_.get(new_defaults, vdp))) {
          console.warn(("[playposit-analytics] Property '" + (vdp.join('.')) + " must be of type <ARRAY>.'"));
        } else {
          _.set(defaults, vdp, _.get(new_defaults, vdp));
        }
      }
    });
    if (options.debug) { console.log('[playposit-analytics] Updated defaults', defaults); }
  }
}

export default analytics;
